/* eslint-disable no-prototype-builtins */
export default function isArrayLike(item: any) {
  return (
    Array.isArray(item)
        || (!!item
          && typeof item === 'object'
          && item.hasOwnProperty('length')
          && typeof item.length === 'number'
          && item.length > 0
          && (item.length - 1) in item
        )
  );
}
